<div
  class="logo m-b-12"
  *ngIf="layoutMode === 'full'">
  <img
    alt=""
    *ngIf="brandingData | async as brandingData"
    [src]="brandingData[BrandingField.FieldLogo]" />
</div>

<div class="p-16">
  <div class="column">
    <app-clearable-input
      #contactListHeaderInput
      [(search)]="search"
      (searchChange)="handleContactSearchInputChange($event)"
      (inputFocus)="searchFocus = true"
      (inputBlur)="searchFocus = false"
      (keyUp)="handleKeyUp($event)"
      (keyDown)="handleKeyDown($event)"
      [label]="searchLabel"
      [class]="'search density-minus-3'">
    </app-clearable-input>
  </div>

  <div class="filter-row">
    @if (filteringEnabled) {
      <div class="select-container">
        <div
          class="select-options"
          [class.recent-calls-enabled]="showRecentCallsTab">
          <div
            class="select-item contacts-tab-item"
            appBrandingColor
            styleType="color"
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            [ngClass]="{ selected: showRecentCallsTab && selectedListTab === 'contacts' }">
            <div
              class="label contacts-option"
              [matMenuTriggerFor]="selectedListTab === 'contacts' ? filterMenu : null"
              #filterMenuTrigger="matMenuTrigger"
              (click)="handleListTabChanged('contacts')">
              <span class="contact-type-label">{{
                selectedContactGroup ? selectedContactGroup.name : (selectedContactType | contactTypeLabel)
              }}</span>
              @if (
                !selectedContactGroup &&
                selectedContactType === ContactType.Company &&
                pbxSiteValues.length > 0 &&
                selectedPBXSites.length > 0
              ) {
                <span
                  class="selected-sites-text-dropdown"
                  matTooltipPosition="above"
                  [matTooltip]="selectedSitesText">
                  - {{ selectedSitesText }}
                </span>
              }
              <mat-icon
                appBrandingColor
                styleType="color"
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                >{{ filterMenuTrigger.menuOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}
              </mat-icon>
            </div>
          </div>
          @if (showRecentCallsTab) {
            <div
              class="select-item"
              appBrandingColor
              styleType="color"
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              [ngClass]="{ selected: selectedListTab === 'recentCalls' }">
              <div
                class="label"
                (click)="handleListTabChanged('recentCalls')">
                {{ 'CALLS.NEW_CALL_CONTACT_LIST_TAB_RECENT_CALLS' | translate }}
              </div>
            </div>
          }
        </div>

        <mat-menu #filterMenu="matMenu">
          <div class="filter">
            <label class="label">{{ 'CALLS.NEW_CALL_CONTACT_LIST_SHOW' | translate }}</label>
            <mat-radio-group
              color="primary"
              class="radio-options">
              @for (item of contactTypeValues; track $index) {
                <mat-radio-button
                  [value]="item"
                  [checked]="!selectedContactGroup && selectedContactType === item"
                  (click)="onContactTypeChanged(item)"
                  [class.company-with-sites]="item === ContactType.Company && pbxSiteValues.length > 0">
                  <span data-cy="radio-option-text">{{ item | contactTypeLabel }}</span>
                  <!-- Selected sites text and toggle button for Company contact type -->
                  @if (item === ContactType.Company && pbxSiteValues.length > 0) {
                    <span class="selected-sites-text">{{ selectedSitesText }}</span>
                    <button
                      mat-icon-button
                      class="site-toggle-button"
                      (click)="toggleSiteFilterExpanded($event)"
                      type="button">
                      <mat-icon>{{ siteFilterExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  }
                </mat-radio-button>

                <!-- Site checkboxes - show when expanded (regardless of selection) -->
                @if (item === ContactType.Company && pbxSiteValues.length > 0 && siteFilterExpanded) {
                  <div class="site-checkboxes-inline">
                    <mat-checkbox
                      color="primary"
                      [checked]="isAllSitesSelected"
                      (click)="onAllSitesToggle($event)">
                      {{ 'CONTACTS.ALL_SITES' | translate }}
                    </mat-checkbox>
                    @for (site of pbxSiteValues; track $index) {
                      <mat-checkbox
                        color="primary"
                        [checked]="isSiteSelected(site)"
                        (click)="onSiteToggle(site, $event)">
                        {{ site }}
                      </mat-checkbox>
                    }
                  </div>
                }
              }

              @for (group of contactGroups; track group.id) {
                <mat-radio-button
                  [value]="group.id"
                  [checked]="selectedContactGroup?.id === group.id"
                  (click)="onContactGroupSelected(group)"
                  data-cy="contact-group-item">
                  <span
                    [matTooltip]="groupTooltip(group)"
                    matTooltipPosition="right"
                    data-cy="radio-option-text">
                    {{ group.name }}
                  </span>
                  @if (group.type === 'shared') {
                    <mat-icon
                      matTooltip="{{ 'CONTACTS.SHARED_GROUP_TOOLTIP' | translate }}"
                      data-cy="shared-icon"
                      class="shared-group-icon">
                      people
                    </mat-icon>
                  }
                  @if (group.canEdit) {
                    <mat-icon
                      (click)="editContactGroup($event, group, filterMenuTrigger)"
                      data-cy="edit-contact-group"
                      class="edit-group-icon">
                      edit
                    </mat-icon>
                  }
                </mat-radio-button>
              }
            </mat-radio-group>

            <button
              type="button"
              class="create-group-item"
              data-cy="create-contact-group"
              (click)="openCreateContactGroupDialog(filterMenuTrigger)">
              <mat-icon>add</mat-icon>
              <span>{{ 'CALLS.NEW_CALL_CONTACT_LIST_CREATE_GROUP' | translate }}</span>
            </button>

            <mat-divider></mat-divider>

            <label class="label">{{ 'CALLS.NEW_CALL_CONTACT_LIST_GROUP_BY' | translate }}</label>
            <mat-radio-group
              color="primary"
              class="radio-options"
              [(ngModel)]="selectedContactGrouping">
              <mat-radio-button
                *ngFor="let item of contactGroupingValues"
                [value]="item"
                (click)="onContactGroupingChanged(item)">
                <span data-cy="radio-option-text">{{ item | contactGroupingLabel }}</span>
              </mat-radio-button>
            </mat-radio-group>
            <mat-divider></mat-divider>

            <label class="label">{{ 'CALLS.NEW_CALL_CONTACT_LIST_SORT_BY' | translate }}</label>
            <mat-radio-group
              color="primary"
              class="radio-options"
              [(ngModel)]="selectedContactSort">
              <mat-radio-button
                *ngFor="let item of contactSortValues"
                [value]="item"
                (click)="onContactSortChanged(item)">
                <span data-cy="radio-option-text">{{ item | contactSortLabel }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-menu>
      </div>
    }

    @let showShared = configService.canAddEditSharedContacts$ | async;
    @if (showShared || hasMicrosoftProvider) {
      @if (layoutMode === 'full') {
        <button
          class="add-contact-button"
          data-cy="add-contact"
          [matMenuTriggerFor]="newMenu"
          #menuTrigger="matMenuTrigger"
          mat-icon-button
          color="primary">
          <mat-icon
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            class="material-icons-outlined"
            >add_box_outlined</mat-icon
          >
        </button>
      }
      <mat-menu
        #newMenu="matMenu"
        class="margin-top-7">
        <span>
          <button
            mat-menu-item
            (click)="addContact()"
            data-cy="add-contact-menu">
            <mat-icon>add</mat-icon>
            <span>{{ 'CALLS.NEW_CALL_CONTACT_LIST_ADD_MY_CONTACT' | translate }}</span>
          </button>
          @if (showShared) {
            <button
              mat-menu-item
              (click)="addContact(ContactType.Shared)">
              <mat-icon>add</mat-icon>
              <span>{{ 'CALLS.NEW_CALL_CONTACT_LIST_ADD_SHARED_CONTACT' | translate }}</span>
            </button>
          }
          @if (hasMicrosoftProvider) {
            <button
              mat-menu-item
              (click)="addContact(ContactType.Microsoft)">
              <mat-icon>add</mat-icon>
              <span>{{ 'CALLS.NEW_CALL_CONTACT_LIST_ADD_MICROSOFT_CONTACT' | translate }}</span>
            </button>
          }
        </span>
      </mat-menu>
    } @else {
      <ng-container>
        @if (layoutMode === 'full') {
          <button
            class="add-contact-button"
            data-cy="add-contact"
            mat-icon-button
            color="primary"
            (click)="addContact()">
            <mat-icon
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color"
              class="material-icons-outlined"
              >add_box_outlined</mat-icon
            >
          </button>
        }
      </ng-container>
    }
  </div>

  <mat-divider></mat-divider>
</div>
